export * from './pandemie.service';
import { PandemieService } from './pandemie.service';
export * from './pandemieCommand.service';
import { PandemieCommandService } from './pandemieCommand.service';
export * from './pandemieQuery.service';
import { PandemieQueryService } from './pandemieQuery.service';
export * from './pandemieTemplates.service';
import { PandemieTemplatesService } from './pandemieTemplates.service';
export const APIS = [PandemieService, PandemieCommandService, PandemieQueryService, PandemieTemplatesService];
